import { Button, TextSize, Weight, FlexColumn, Flex, Image } from 'components'

import styled from 'styled-components'

//styling for the portfolio composition card (the wrapper)
export const PortfolioCompositionWrapper = styled.div`
  margin-bottom: 60px;
  border-radius: 20px;
  width: fill-available;
  color: ${({ theme }) => theme.primaryFontColor};
  display: flex;
  flex-direction: column;
  gap: 30px;
`

export const CompositionTitleStyle = styled.span`
  font-size: ${TextSize.two};
  font-weight: ${Weight.Medium};
  line-height: 27.158px;
`

//wrapper for composition map
export const AssetsCompositionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

// wrapper for the data in individual asset
export const AssetDataWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 15px;
`

//image wrapper for the icon
export const AssetIconImage = styled(Image)`
  width: 24px;
  height: 24px;
`

// styling for data text
export const AssetDataTextStyle = styled.span`
  font-size: ${TextSize.small};
  font-weight: ${Weight.Bold};
  min-width: 40px;
`
// wrapper for the bar
export const AssetBarWrapper = styled.div`
  width: 100%;
  flex-grow: 1;
  height: 8px;
  margin-left: 10px;
`

// bar style that takes a property for width percentage
export const AssetBarStyle = styled.div<{ width: number; color: string }>`
  width: ${({ width }) => width}%;
  height: 100%;
  background-color: ${({ color }) => color};
  border-radius: 20px;
`

export const StyledText = styled.span`
  font-size: ${TextSize.p};
  color: ${({ theme }) => theme.secondaryFontColor};
`

export const Invest = styled(Button)`
  display: flex;
  width: 84px;
  height: 40px;
`

export const SkeletonColumn = styled(FlexColumn)`
  gap: 20px;
`
export const SkeletonRow = styled(Flex)`
  gap: 20px;
`
